module.exports = __webpack_public_path__ + "static/media/alunos.3cde2198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/bottombar/alunos.svg
// module id = ./src/statics/bottombar/alunos.svg
// module chunks = 0